import React, { useState, useEffect } from 'react';
import { CartContext } from './CartContext';

export const CartProvider = ({ children }) => {
  const [cartItems, setCartItems] = useState(() => {
    if (typeof window !== 'undefined') {
      const saved = localStorage.getItem('cart');
      return saved ? JSON.parse(saved) : [];
    }
    return [];
  });

  const [isCartOpen, setIsCartOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem('cart', JSON.stringify(cartItems));
  }, [cartItems]);

  const addItem = (item) => {
    setCartItems(prev => {
      // If item with same id already exists, update it or add as new?
      // For campaigns, it might make sense to replace or add another entry.
      // Let's go with adding another entry or merging if id matches.
      const existing = prev.find(i => i.id === item.id);
      if (existing) {
        return prev.map(i => i.id === item.id ? { ...i, ...item } : i);
      }
      return [...prev, item];
    });
    setIsCartOpen(true);
  };

  const removeItem = (id) => {
    setCartItems(prev => prev.filter(item => item.id !== id));
  };

  const clearCart = () => {
    setCartItems([]);
  };

  const totalAmount = cartItems.reduce((sum, item) => sum + (item.totals?.grandTotal || 0), 0);

  return (
    <CartContext.Provider value={{ 
      cartItems, 
      addItem, 
      removeItem, 
      clearCart, 
      isCartOpen, 
      setIsCartOpen,
      totalAmount 
    }}>
      {children}
    </CartContext.Provider>
  );
};
